import { useEffect, useState } from 'react';

export const useScrollState = (ref: React.RefObject<HTMLDivElement | null>) => {
  const [scrollState, setScrollState] = useState({ isTop: true, isBottom: false });

  useEffect(() => {
    const handleScroll = () => {
      if (ref.current) {
        const { scrollTop, scrollHeight, clientHeight } = ref.current;
        setScrollState({
          isTop: scrollTop === 0,
          isBottom: scrollTop + clientHeight >= scrollHeight
        });
      }
    };

    const container = ref.current;
    if (container) {
      container.addEventListener('scroll', handleScroll);
    }

    return () => container?.removeEventListener('scroll', handleScroll);
  }, [ref]);

  return scrollState;
};
